// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"597":"aa65295a","687":"2cd1574e","708":"61dabead","833":"aa65295a"}[chunkId] + ".chunk.css";
};